import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicTextArea, BaasicFieldDropdown, BaasicFormControls, BasicFieldCheckbox, BaasicButton, BaasicModal } from 'core/components';
import { toDate, toUTCDate, isNikoFlowTask } from 'core/utils';
import { TaskComment } from 'application/schedule/components';
import { FacilityOrderNewFlowConfirmModal } from "application/facility-order-new-flow/components";
function CalendarEventEditTemplate({ eventEditStore, t }) {
    const {
        form,
        accountRepStore,
        item,
        titleData,
        rootStore,
        intakeRepStore,
        payorRepStore,
        documentRepStore,
        billingRepStore,
        modalParams,
        isDeliveryLink,
        isPayorRepAssignee,
        isIntakeRepAssignee,
        isDocumentRepAssignee,
        isBillingRepAssignee,
        isUserAccountManager,
        isAdmin,
        isAccountManager,
        deliveryTask,
        statistic,
        dateOfService,
        deliveryDate,
        orderingDate,
        facilityNote,
        corporateNote,
        copyNote,
        partBOnly,
        isOrderingCalType,
        isPandaDoc,
        getFacilityOrderRoute,
        openPickTicket,
        openNikoFacilityOrder,
        downloadDeliveryTicketNiko,
        prepDayConfirmationModal
    } = eventEditStore;
    return (
        <section>
            {item != null && <form className='form' onSubmit={form.onSubmit}>
                <div className='modal__header'>
                    <h3 className="modal__header__title u-mar--right--sml">
                        {titleData.facility + (titleData.areaOfCare ? ', ' + titleData.areaOfCare : '')}
                    </h3>
                    <div className="u-flex--primary">
                        <a title={t('FACILITY.LIST.BUTTON.PREVIEW')}
                            className="u-mar--right--sml"
                            href={"/facilities/preview/" + item.facility.id} target="_blank">
                            <i className="u-icon u-icon--preview u-icon--sml"></i>
                        </a>
                        <a title={t('FACILITY.LIST.BUTTON.EDIT')}
                            className="u-mar--right--sml"
                            href={"/facilities/edit/" + item.facility.id} target="_blank">
                            <i className="u-icon u-icon--edit u-icon--sml"></i>
                        </a>
                        <a title={t('FACILITY.LIST.BUTTON.SCHEDULE')}
                            className="u-mar--right--sml"
                            href={"/facilities/schedule/" + item.facility.id} target="_blank">
                            <i className="u-icon u-icon--schedule u-icon--sml"></i>
                        </a>
                        {
                            isNikoFlowTask(item.facility, dateOfService) ?
                                (!item.isAreaOfCareWoundCare && isOrderingCalType &&
                                    <a title={t('SCHEDULE.CALENDAR.EDIT.ACCESS_FACILITY_ORDER')}
                                        className="u-mar--right--sml"
                                        onClick={() => openNikoFacilityOrder()}>
                                        <i className="u-icon u-icon--package--grey u-icon--sml"></i>
                                    </a>
                                )
                                :
                                (item.facilityOrderId &&
                                    <a title={t('FACILITY_ORDER.LIST.TITLE')}
                                        className="u-mar--right--sml"
                                        onClick={() => getFacilityOrderRoute()}>
                                        <i className="u-icon u-icon--package--grey u-icon--sml"></i>
                                    </a>
                                )
                        }
                    </div>
                </div>

                <div className="modal__body">
                    <div className="row">
                        <div className="form__group col col-lrg-4">
                            Ordering Date: {toUTCDate(orderingDate)}
                        </div>
                        <div className="form__group col col-lrg-4">
                            Date Of service: {dateOfService ? toUTCDate(dateOfService) : "-"}
                        </div>
                        <div className="form__group col col-lrg-4">
                            Delivery Date: {toUTCDate(deliveryDate)}
                        </div>
                    </div>
                    <div className="row">
                        <div className="form__group col col-sml-12 col-lrg-6">
                            <div className="u-flex--space-between">
                                <label className="form__group__label">
                                    Account Manager
                                </label>
                                {item.facility.accountRepId !== item.accountRepId &&
                                    <div className='u-flex--primary u-mar--left--auto'>
                                        <i className="u-icon calendar__icon acc-rep-change dark"></i>
                                    </div>
                                }
                            </div>
                            <BaasicFieldDropdown
                                field={form.$('accountRepId')}
                                store={accountRepStore}
                                disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isUserAccountManager)}
                                labelDisplayed={false}
                            />
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-6 u-flex--self--center">
                            <div className="u-flex--primary u-flex--align-start">
                                <div className="u-mar--right--xsml">
                                    <div>
                                        <BasicFieldCheckbox
                                            field={form.$('isDone')}
                                            disabled={(item.isDone && !isAccountManager && !isAdmin) || (!rootStore.permissionStore.hasPermission('calendarSection.update'))}
                                        />
                                    </div>
                                    {item.isDoneDate && <sub>[{toDate(item.isDoneDate, true)}]</sub>}
                                </div>
                                <div>
                                    <BasicFieldCheckbox
                                        field={form.$('noSupply')}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {!partBOnly && !item.isAreaOfCareWoundCare && isOrderingCalType ?
                        <div className="u-display--ib u-mar--bottom--tny">
                            <BasicFieldCheckbox label="Missing Inventory Count" field={form.$('missingInventoryCount')} />
                        </div>
                        :
                        ""
                    }
                    <div className="row">
                        <div className="form__group col col-sml-12 col-lrg-6">
                            <div className="u-mar--bottom--tny">
                                <div className='form__group__header'>
                                    <label className="form__group__label">
                                        Intake Specialist
                                    </label>
                                    <div className='u-flex--primary u-mar--left--auto'>
                                        {(item.isAreaOfCareWoundCare ? item.facility.woundCareRepId !== item.intakeRepId : item.facility.intakeRepId !== item.intakeRepId) && <i className="u-icon calendar__icon acc-rep-change dark"></i>}
                                    </div>
                                    <BasicFieldCheckbox
                                        field={form.$('isReminderIntake')}
                                        checkedIconClass="u-icon--flag--red"
                                        unCheckedIconClass="u-icon--flag"
                                    />
                                </div>
                                <BaasicFieldDropdown
                                    field={form.$('intakeRepId')}
                                    labelDisplayed={false}
                                    store={intakeRepStore}
                                    disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isUserAccountManager)}
                                />
                            </div>
                            <div className="u-flex--primary">
                                <div className="u-mar--bottom--xsml u-mar--right--sml">
                                    <div className="u-display--ib">
                                        <BasicFieldCheckbox field={form.$('isDoneIntake')} disabled={
                                            item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') &&
                                                !isIntakeRepAssignee &&
                                                !isUserAccountManager)}
                                        />
                                    </div>
                                    {item.isDoneIntakeDate && <sub>[{toDate(item.isDoneIntakeDate, true)}]</sub>}
                                </div>

                                {item.isCoverageTypeAll && !item.isAreaOfCareWoundCare &&
                                    <div className="u-mar--bottom--xsml u-mar--right--sml">
                                        <div className="u-display--ib">
                                            <BasicFieldCheckbox field={form.$('isInventoryDone')} disabled={
                                                item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') &&
                                                    !isIntakeRepAssignee &&
                                                    !isUserAccountManager &&
                                                    !rootStore.userStore.user.roles.includes("OffshoreRep")) ||
                                                !form.$('isDoneIntake').value}
                                            />
                                        </div>
                                        {item.isInventoryDoneDate && <sub>[{toDate(item.isInventoryDoneDate, true)}]</sub>}
                                    </div>
                                }
                                {(!item.facility.partBOnly && (item.isAreaOfCareWoundCare || item.facility.requiredSecondPayor || (item.facility.corporate_ && item.facility.corporate_.requiredSecondPayor))) ? null :
                                    (item.facility.partBOnly || item.isAreaOfCareWoundCare || item.facility.requiredSecondPayor ||
                                        (item.facility.corporate_ && item.facility.corporate_.requiredSecondPayor)) &&
                                    <div className="u-display--ib u-mar--bottom--xsml u-mar--right--sml">
                                        <BasicFieldCheckbox field={form.$('productInfoNeeded')} disabled={item.isDone} />
                                    </div>
                                }
                            </div>
                            <div className='inputgroup'>
                                <div className='inputgroup--main'>
                                    <BasicTextArea rows="2" field={form.$('intakeNote')} />
                                </div>
                                <div className="inputgroup--aside">
                                    <span className='type--wgt--regular '>
                                        <a target='_blank' onClick={() => copyNote('IntakeNote')} className="u-mar--left--tny"><i className="u-icon u-icon--sml u-icon--note"></i></a>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="form__group col col-sml-12 col-lrg-6">
                            <div className="u-mar--bottom--tny">
                                <div className="form__group__header">
                                    <label className="form__group__label">
                                        Insurance Specialist
                                    </label>
                                    <div className='u-flex--primary u-mar--left--auto'>
                                        {item.facility.payorRepId !== item.payorRepId && <i className="u-icon calendar__icon acc-rep-change dark"></i>}
                                    </div>
                                    <BasicFieldCheckbox
                                        field={form.$('isReminderPayor')}
                                        checkedIconClass="u-icon--flag--red"
                                        unCheckedIconClass="u-icon--flag"
                                    />
                                </div>
                                <BaasicFieldDropdown
                                    field={form.$('payorRepId')}
                                    store={payorRepStore}
                                    labelDisplayed={false}
                                    disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isUserAccountManager)}
                                />
                            </div>
                            <div className="u-flex--primary">
                                <div className="u-mar--bottom--xsml u-mar--right--sml">
                                    <div className="u-display--ib">
                                        <BasicFieldCheckbox field={form.$('isDonePayor')} disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isPayorRepAssignee && !isUserAccountManager)} />
                                    </div>
                                    {item.isDonePayorDate && <sub>[{toDate(item.isDonePayorDate, true)}]</sub>}
                                </div>

                                {(item.facility.partBOnly || item.isAreaOfCareWoundCare || item.facility.requiredSecondPayor || (item.facility.corporate_ && item.facility.corporate_.requiredSecondPayor)) &&
                                    <React.Fragment>
                                        <div className="u-mar--bottom--xsml">
                                            <div>
                                                <BasicFieldCheckbox field={form.$('isSecondCheckDone')} disabled={
                                                    item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') &&
                                                        !isPayorRepAssignee &&
                                                        !isUserAccountManager &&
                                                        !rootStore.userStore.user.roles.includes("OffshoreRep")) ||
                                                    !form.$('isDonePayor').value} />
                                            </div>
                                            {item.isSecondCheckDoneDate && <sub>[{toDate(item.isSecondCheckDoneDate, true)}]</sub>}
                                        </div>
                                    </React.Fragment>
                                }
                            </div>
                            <div className='inputgroup'>
                                <div className='inputgroup--main'>
                                    <BasicTextArea rows="2" field={form.$('payorNote')} />
                                </div>
                                <div className="inputgroup--aside">
                                    <span className='type--wgt--regular '>
                                        <a target='_blank' onClick={() => copyNote('PayorNote')} className="u-mar--left--tny"><i className="u-icon u-icon--sml u-icon--note"></i></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-6">
                            <div className="u-mar--bottom--tny">
                                <div className="form__group__header">
                                    <label className="form__group__label">
                                        Clinical Review
                                    </label>
                                    <div className='u-flex--primary u-mar--left--auto'>
                                        {(item.isAreaOfCareWoundCare ? item.facility.woundCareRepId !== item.documentRepId : item.facility.documentRepId !== item.documentRepId) && <i className="u-icon calendar__icon acc-rep-change dark"></i>}
                                        <BasicFieldCheckbox
                                            field={form.$('isReminderDocument')}
                                            checkedIconClass="u-icon--flag--red"
                                            unCheckedIconClass="u-icon--flag"
                                        />
                                    </div>
                                </div>
                                <BaasicFieldDropdown
                                    field={form.$('documentRepId')}
                                    store={documentRepStore}
                                    disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isUserAccountManager)}
                                    labelDisplayed={false}
                                />
                            </div>
                            <div className="u-flex--primary u-mar--bottom--xsml u-height--42">
                                <div className="u-display--ib">
                                    <BasicFieldCheckbox field={form.$('isDoneDocument')} disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isDocumentRepAssignee && !isUserAccountManager)} />
                                </div>
                                {isPandaDoc &&
                                    <div className="u-mar--left--tny">
                                        <i className="u-icon u-icon--sml u-icon--panda-doc u-mat--bottom--xtny" />
                                    </div>
                                }
                                {item.isDoneDocumentDate && <sub className="u-display--b w--100">[{toDate(item.isDoneDocumentDate, true)}]</sub>}
                            </div>
                            <div className='inputgroup'>
                                <div className='inputgroup--main'>
                                    <BasicTextArea rows="2" field={form.$('documentNote')} />
                                </div>
                                <div className="inputgroup--aside">
                                    <span className='type--wgt--regular '>
                                        <a target='_blank' onClick={() => copyNote('DocumentNote')} className="u-mar--left--tny"><i className="u-icon u-icon--sml u-icon--note"></i></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-6">
                            <div className='u-mar--bottom--tny'>
                                <div className="form__group__header">
                                    <label className="form__group__label">
                                        Biller
                                    </label>
                                    <div className='u-flex--primary u-mar--left--auto'>
                                        {item.facility.billingRepId !== item.billingRepId && <i className="u-icon calendar__icon acc-rep-change dark"></i>}
                                    </div>
                                    <BasicFieldCheckbox
                                        field={form.$('isReminderBiller')}
                                        checkedIconClass="u-icon--flag--red"
                                        unCheckedIconClass="u-icon--flag"
                                    />
                                </div>
                                <BaasicFieldDropdown
                                    field={form.$('billingRepId')}
                                    store={billingRepStore}
                                    disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isUserAccountManager)}
                                    labelDisplayed={false}
                                />
                            </div>
                            <div className='u-flex--primary u-flex--align-items--center u-height--42 u-mar--bottom--xsml'>
                                <div className="u-mar--right--sml">
                                    <div>
                                        <BasicFieldCheckbox field={form.$('isDoneBiller')} disabled={item.isDone || (!rootStore.permissionStore.hasPermission('calendarSection.update') && !isBillingRepAssignee && !isUserAccountManager)} />
                                    </div>
                                    {item.isDoneBillerDate && <sub>[{toDate(item.isDoneBillerDate, true)}]</sub>}
                                </div>
                                <div>
                                    <div>
                                        <BasicFieldCheckbox field={form.$('sendOrder')} disabled={item.isDone} />
                                    </div>
                                    {item.sendOrderDate && <sub>[{toDate(item.sendOrderDate, true)}]</sub>}
                                </div>
                                {
                                    item && !isNikoFlowTask(item.facility, dateOfService) && item.facilityOrder && item.facilityOrder !== null && item.facilityOrder.id && item.facilityOrder.pickTicketHeaderId && !item.isAreaOfCareWoundCare && item.facilityOrder.sendOrder &&
                                    <div className="u-mar--left--sml u-cursor--pointer">
                                        <span className='type--wgt--regular' onClick={() => openPickTicket(item.facilityOrder, item.facilityOrder.pickTicketHeaderId)}>
                                            <u>Pick Ticket</u>
                                        </span>
                                    </div>
                                }
                                {
                                     item && isNikoFlowTask(item.facility, dateOfService) && item.facilityOrderId && !item.isAreaOfCareWoundCare && isOrderingCalType && item.facilityOrder && item.facilityOrder.sendOrder &&
                                    <div className="u-mar--left--sml u-cursor--pointer">
                                        <span className='type--wgt--regular' onClick={() => downloadDeliveryTicketNiko()}>
                                            <u>Delivery Ticket</u>
                                        </span>
                                    </div>
                                }
                            </div>
                            <div className='inputgroup'>
                                <div className='inputgroup--main'>
                                    <BasicTextArea rows="2" field={form.$('billingNote')} />
                                </div>
                                <div className="inputgroup--aside">
                                    <span className='type--wgt--regular '>
                                        <a target='_blank' onClick={() => copyNote('BillingNote')} className="u-mar--left--tny"><i className="u-icon u-icon--sml u-icon--note"></i></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-6">
                            Corporate Notes: {corporateNote != "" ? (<i className="u-mar--right--sml">{corporateNote}</i>) : "- "}
                        </div>
                        <div className="form__group col col-sml-12 col-lrg-6">
                            Facility Notes: {facilityNote != "" ? (<i className="u-mar--right--sml">{facilityNote}</i>) : "- "}
                        </div>
                    </div>
                    <div className='inputgroup form__group'>
                        <div className='inputgroup--main'>
                            <BasicTextArea rows="1" disabled={item.isDone} field={form.$('notes')} />
                        </div>
                        <div className="inputgroup--aside u-padd--top--med">
                            <span className='type--wgt--regular '>
                                <a target='_blank' onClick={() => copyNote('Note')} className="u-mar--left--tny"><i className="u-icon u-icon--sml u-icon--note"></i></a>
                            </span>
                        </div>
                    </div>
                    {isDeliveryLink &&
                        <div className="row">
                            <div className="form__group col col-sml-12">
                                <BasicTextArea rows="1" disabled={item.isDone} field={form.$('deliveryNotes')} />
                            </div>
                            <div className="form__group col col-sml-12 col-med-6">
                                Order Detail Notes: {deliveryTask.orderingDetailNote != "" ? (<i className="u-mar--right--sml">{deliveryTask.orderingDetailNote}</i>) : "- "}
                            </div>
                            <div className='form__group col col-sml-12 col-med-6 type--color--warning'>
                                Backorder Notes: {deliveryTask.backorderNote != "" ? (<i>{deliveryTask.backorderNote} </i>) : "-"}
                            </div>
                        </div>
                    }
                    {/* {pastOrders && pastOrders.length > 0 ?
                        <React.Fragment>
                            <h4 className="form__title">Move to another Date</h4>
                            <div className="u-mar--bottom--sml">
                                {dates}
                            </div>
                        </React.Fragment>
                    : null} */}
                    <TaskComment facilityScheduleDateId={item.id} />
                </div>
                <div className="modal__footer is-left">
                    <BaasicFormControls
                        form={form}
                        onSubmit={form.onSubmit}
                        disabled={form.submitting || form.validating}
                        className='btn btn--med btn--primary'
                        label="Save"
                    />
                    <BaasicButton
                        className='btn btn--med btn--light'
                        label={t('EDIT_FORM_LAYOUT.CANCEL')}
                        onClick={() => modalParams.close()}
                    />
                    {!item.isAreaOfCareWoundCare &&
                        <p className="u-flex--grow--1 type--color--opaque type--right">
                            No. Patients {statistic ? statistic.patientCount : "-"},  No. Templates {statistic ? statistic.templateCount : "-"}  (DOS {statistic && statistic.dateOfService ? toUTCDate(statistic.dateOfService) : "-"})
                        </p>
                    }
                </div>
            </form>}
            <BaasicModal modalParams={prepDayConfirmationModal} className="modal__content modal--sml">
                <FacilityOrderNewFlowConfirmModal />
            </BaasicModal>
        </section>
    );
}

CalendarEventEditTemplate.propTypes = {
    eventEditStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(CalendarEventEditTemplate);
